import equals from 'ramda/src/equals'
import anyPass from 'ramda/src/anyPass'
import { projectApprovedKey, projectAcceptedKey, projectDeliveryPendingKey } from 'root/src/shared/constants/keys'
import statusSelector from 'root/src/client/logic/project/selectors/statusSelector'
import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'

export default (state, props) => anyPass([
	equals(statusSelector(state, props), projectApprovedKey),
	equals(statusSelector(state, props), projectAcceptedKey),
	equals(statusSelector(state, props), projectDeliveryPendingKey),
])
	&& isAdminSelector(state, props)
